import changeCart from '../../lib/changeCart';
import { initSwiper } from '../../components/swiper';
import initCartUpsellAtc from '../../components/cart-upsell-atc';
import renderCartUpsellRecommendations from '../../lib/renderCartUpsellRecommendations';
import { EVENTS } from '../../utils/constants';

const initCartPage = () => {
  const getSectionEl = () => document.querySelector('[data-cart-line-items]')?.closest('.shopify-section');
  const initialSectionEl = getSectionEl();
  if (!initialSectionEl) return;

  const sectionId = initialSectionEl.id.replace('shopify-section-', '');

  const setLineItemLoadingState = (el) => {
    el?.classList.add('opacity-50', 'pointer-events-none');
  };

  const reinitCartUpsell = () => {
    const sliderEl = document.querySelector('[data-cart-upsell] [data-swiper]');
    if (!sliderEl) return;
    initSwiper(sliderEl);
    initCartUpsellAtc();
  };

  const renderCartSection = async () => {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart?sections=${sectionId}`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const sections = await res.json();
      const markup = sections[sectionId];
      const sectionEl = getSectionEl();
      if (!markup || !sectionEl) throw new Error('Missing cart section markup');

      const parser = new DOMParser();
      const doc = parser.parseFromString(markup, 'text/html');
      const newSectionEl = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      if (!newSectionEl) throw new Error('Missing cart section markup');
      sectionEl.innerHTML = newSectionEl.innerHTML;

      reinitCartUpsell();
      await renderCartUpsellRecommendations();
      // The section body is replaced wholesale, so anything a third party
      // injected into it is gone — this is their cue to re-inject.
      document.dispatchEvent(new CustomEvent(EVENTS.CART_RENDERED, { detail: { cartEl: sectionEl } }));
    } catch (e) {
      console.error('Failed to re-render cart:', e);
      window.location.reload();
    }
  };

  document.addEventListener('click', async (evt) => {
    const removeBtn = evt.target.closest('[data-cart-remove-item]');
    const minusBtn = evt.target.closest('[data-cart-qty-minus]');
    const plusBtn = evt.target.closest('[data-cart-qty-plus]');
    const actionBtn = removeBtn || minusBtn || plusBtn;
    if (!actionBtn || actionBtn.disabled) return;
    evt.preventDefault();

    const lineItemEl = actionBtn.closest('[data-cart-line-item]');
    const quantityEl = lineItemEl?.querySelector('[data-line-item-quantity]');
    const currentQty = Number(quantityEl?.dataset.lineItemQuantity);

    let newQty = null;
    if (removeBtn) {
      newQty = 0;
    } else if (minusBtn && currentQty > 1) {
      newQty = currentQty - 1;
    } else if (plusBtn && currentQty > 0) {
      newQty = currentQty + 1;
    }
    if (newQty === null) return;

    const lineItemKey = removeBtn?.dataset.cartRemoveItem
      || minusBtn?.dataset.cartQtyMinus
      || plusBtn?.dataset.cartQtyPlus;

    setLineItemLoadingState(lineItemEl);
    await changeCart(lineItemKey, newQty);
    await renderCartSection();
  });

  document.addEventListener(EVENTS.CART_CHANGED, renderCartSection);

  renderCartUpsellRecommendations();
};

export default initCartPage;
